import React from 'react';
import { useOfflineState } from './useOfflineState';
import { useQuickload } from './useQuickload';
import { TrelloOnline } from 'app/src/components/TrelloOnline';

export const App = () => {
  const wasEverOffline = useOfflineState();
  const isQuickloading = useQuickload();

  if (wasEverOffline) {
    window.location.href = `/offline?returnUrl=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }

  return isQuickloading ? null : <TrelloOnline />;
};
